import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseModalWithProfilePhotoComponent } from '../base-modal-with-profile-photo/base-modal-with-profile-photo.component';
import { CalendarEventModel } from 'src/app/core/models/calendar/calendar.model';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import Swal from 'sweetalert2';
import { CalendarListService } from 'src/app/core/services/list-services/calendar-list.service';
import { AttendeeModel } from 'src/app/core/models/calendar/attendee.model';
import { CalendarEventStatusEnum } from 'src/app/core/enums/calendar-status-enum';
import { Subscription } from 'rxjs';
import { UserModel } from 'src/app/core/models/members/user/user.model';
import { EntityTypeEnum } from 'src/app/core/enums/entity-type-id-enum';

import moment from 'moment';
import { GlobalComponent } from 'src/app/global-component';
import { LoginType } from 'src/app/core/models/members/user/user-context.model';
import { ClientModel } from 'src/app/core/models/members/client/client.model';

@Component({
  selector: 'app-calendar-event-modal',
  templateUrl: './calendar-event-modal.component.html',
  styleUrls: ['./calendar-event-modal.component.scss']
})
export class CalendarEventModalComponent extends BaseModalWithProfilePhotoComponent {

  userEventStatusOptions = [
    { value: CalendarEventStatusEnum.None, selectedText: $localize`:@@:RSVP`, dropdownText: $localize`:@@:RSVP`, default: true },
    { value: CalendarEventStatusEnum.Accepted, selectedText: $localize`:@@:Accepted`, dropdownText: $localize`:@@:Accept` },
    { value: CalendarEventStatusEnum.Declined, selectedText: $localize`:@@:Declined`, dropdownText: $localize`:@@:Decline` },
    { value: CalendarEventStatusEnum.Tentative, selectedText: $localize`:@@:Tentative`, dropdownText: $localize`:@@:Tentative` }
  ]

  eventStatusOptions = [
    { value: "bg-soft-primary", selectedText: $localize`:@@:Blue`, dropdownText: $localize`:@@:Blue` },
    { value: "bg-soft-info", selectedText: $localize`:@@:Cyan`, dropdownText: $localize`:@@:Cyan` },
    { value: "bg-soft-danger", selectedText: $localize`:@@:Red`, dropdownText: $localize`:@@:Red` },
    { value: "bg-soft-warning", selectedText: $localize`:@@:Yellow`, dropdownText: $localize`:@@:Yellow` },
    { value: "bg-soft-success", selectedText: $localize`:@@:Green`, dropdownText: $localize`:@@:Green` },
    { value: "bg-soft-dark", selectedText: $localize`:@@:Dark`, dropdownText: $localize`:@@:Dark` },
  ]

  // editor = ClassicEditor;
  // editorContent = ``;
  // editorConfig = {
  //   toolbar: {
  //     shouldNotGroupWhenFull: true,
  //     items: [ 
  //       'heading',
  //        '|',
  //       'bold', 'italic', 
  //       '|',
  //       'outdent', 'indent', 
  //       '|',
  //       'bulletedList', 'numberedList', 
  //       '|',
  //       'undo', 'redo'
  //     ]
  //   }

  // }
  eventOccursWithinOneDay: boolean = false;
  userEventStatus: { value: CalendarEventStatusEnum | undefined, selectedText: string, dropdownText: string } | any;
  ownerModel: AttendeeModel | undefined;
  showPreviewModel: boolean = false;
  organizerName: string | undefined;
  invalidTimeRange: boolean = false;
  enumCalendarEventStatus = CalendarEventStatusEnum;

  enumEntityType = EntityTypeEnum;
  attendeeProfile = GlobalComponent.defaultUserImage;

  @Input() public override model = new CalendarEventModel();
  @Input() public isOwnerOfEvent: boolean = false;

  @Output() modelUpdated = new EventEmitter<CalendarEventModel | undefined | boolean>();
  @Output() modelDeleted = new EventEmitter<undefined | boolean>();

  constructor(
    protected override myFileApiService: MyfileApiService,
    protected calendarListService: CalendarListService,
    protected override authMyFileService: AuthMyfileService,
    protected override modalRef: NgbActiveModal,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override sanitizer: DomSanitizer
  ) {
    super(myFileApiService, authMyFileService, modalRef, toasterNotificationService, sanitizer);
  }

  override ngOnInit(): void {

    if (this.model.category == undefined || this.model.category.length === 0) {
      this.model.category = "bg-soft-primary";
    }

    var currentDate = new Date();
    var currentTime = currentDate.getHours();
    if (currentDate.getMinutes() > 30) {
      currentTime = currentTime + 1;
    }
    if (currentTime >= 24) {
      currentTime = currentTime - 24;
    }

    if (this.model.date.from !== undefined && this.model.date.to !== undefined) {
      if (this.model.allDayEvent === false) {
        if (this.model.id != undefined) {
          this.model.startTime = `${this.model.date.from.getHours()}:${this.model.date.from.getMinutes()}`;
          this.model.endTime = `${this.model.date.to.getHours()}:${this.model.date.to.getMinutes()}`;
        } else {

          this.model.startTime = `${currentTime}:00`;
          this.model.endTime = `${currentTime}:30`;
        }
      }
    } else {
      this.model.date = undefined;
      this.model.startTime = `${currentTime}:00`;
      this.model.endTime = `${currentTime}:30`;
    }

    if (this.model.date && moment(this.model.date.from).isSame(moment(this.model.date.to), 'day')) {
      this.eventOccursWithinOneDay = true;
    } else {
      this.eventOccursWithinOneDay = false;
    }

    if (this.model.id === undefined) {
      this.newModel = true;
    } else {
      this.showPreviewModel = true;
    }

    if (this.model.attendees) {
      this.model.attendees.splice(0, 1);
      if (this.isOwnerOfEvent === false) {
        this.userEventStatus = this.userEventStatusOptions[0];
        this.model.attendees.forEach(attendee => {
          if (attendee.email == this.authMyFileService.currentUserContextValue?.email) {
            this.userEventStatus = this.userEventStatusOptions[this.userEventStatusOptions.findIndex(x => x.value === attendee.status)];
          }
        })
      }
    }

    this.myFileApiService.getBusinessUnitForCurrentUser().subscribe(result => {
      if (result) {
        if (this.authMyFileService.currentUserContextValue?.loginType === LoginType.Client) {
          var sub: Subscription = this.myFileApiService.getClient()
            .subscribe((clientModel: ClientModel | undefined) => {
              if (clientModel) {
                this.organizerName = clientModel.fullName;
              }
              sub.unsubscribe();
            });
        } else {
          var sub: Subscription = this.myFileApiService.getUser(this.model.createdById)
            .subscribe((userModel: UserModel | undefined) => {
              if (userModel) {
                this.organizerName = userModel.fullName;

                this.loadProfilePhoto(userModel.id!, EntityTypeEnum.User, userModel.profilePhotoFileId, userModel.fullName);

              }
              sub.unsubscribe();
            });
        }


      }
    });
  }

  override ngOnDestroy(): void {

  }

  override validate(): boolean {

    this.invalidTimeRange = false;
    if (
      this.model.title && this.model.title.length > 0 &&
      this.model.category && this.model.category.length > 0 &&
      this.model.date && (this.model.date.from != undefined) &&
      (
        (this.model.allDayEvent === true)
        ||
        (this.model.allDayEvent === false &&
          this.model.startTime && this.model.startTime.length > 0 &&
          this.model.endTime && this.model.endTime.length > 0)
      )
    ) {
      if (this.model.allDayEvent === false && (new Date(this.model.date.from).getTime() >= new Date(this.model.date.to).getTime())) {
        this.toasterNotificationService.showWarning($localize`:@@:End time cannot be earlier then Start time.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
        this.invalidTimeRange = true;
        return false;
      }

      return true;
    }
    this.toasterNotificationService.showWarning($localize`:@@Toast_Error_FeildsRequiredText:Something went wrong. Please make sure all fields are filled in correctly.`, $localize`:@@Toast_Warn_Title_MissingInformation:Missing Information`);
    return false;
  }

  override onUpdate(): void {
    this.updateModelDateAndTime();
    this.setAttendeesModel();
    if (this.validate()) {
      this.myFileApiService.updateCalendar(this.model).subscribe((result) => {
        if (result) {
          this.modalRef.close();
        }
      })
    }
  }

  override onCreate(): void {

    this.updateModelDateAndTime();
    this.setAttendeesModel();

    if (this.validate()) {
      this.myFileApiService.createCalendar(this.model).subscribe((result) => {
        if (result) {
          result
          this.modalRef.close();
        }
      })
    }
  }

  setAttendeesModel() {
    if (this.ownerModel === undefined) {
      this.ownerModel = new AttendeeModel(this.authMyFileService.currentUserContextValue?.id!, EntityTypeEnum.User, CalendarEventStatusEnum.None, this.authMyFileService.currentUserContextValue?.email!, this.authMyFileService.currentUserContextValue?.email);
    }
    this.model.attendees.splice(0, 0, this.ownerModel!)
  }

  updateModelDateAndTime() {

    this.model.date.from = new Date(this.model.date.from

    );
    if (this.model.allDayEvent === true) {
      this.model.date.to = new Date(this.model.date.from);
      this.model.date.to.setDate(this.model.date.to.getDate() + 1)
    }

    if (this.model.allDayEvent === false) {
      if (this.model.date.to == undefined || this.model.date.to == null) {
        this.model.date.to = new Date(this.model.date.from);
      }
      this.model.date.from.setHours(Number(this.model.startTime?.split(':')[0]), Number(this.model.startTime?.split(':')[1]));
      this.model.date.to.setHours(Number(this.model.endTime?.split(':')[0]), Number(this.model.endTime?.split(':')[1]));
    }

    this.model.date.from = this.model.date.from.toISOString();
    this.model.date.to = this.model.date.to.toISOString();

    this.model.start = this.model.date.from;
    this.model.end = this.model.date.to;
  }

  delete() {
    Swal.fire({
      title: $localize`:@@:Are you sure you want to delete the event?`,
      icon: 'warning',
      color: 'var(--vz-body-color)',
      background: 'var(--vz-body-bg)',
      showCancelButton: true,
      confirmButtonColor: 'rgb(3, 142, 220)',
      cancelButtonColor: 'rgb(243, 78, 78)',
      confirmButtonText: $localize`:@@:Delete`,
      cancelButtonText: $localize`:@@:Cancel`
    }).then((result) => {
      if (result.value) {
        this.myFileApiService.deleteCalendar(this.model.id!).subscribe((result) => {
          if (result) {
            //No Delete End Point
            this.modalRef.close();
          };
        });

      }
    });
  }

  updateAttendees(attendees: AttendeeModel[]) {
    this.model.attendees = attendees;
  }

  userStatusUpdate(newStatus: any) {
    this.userEventStatus = newStatus;
    this.myFileApiService.updateCalendarUserStatus(this.model.id!, this.authMyFileService.currentUserContextValue!.email!, newStatus.value).subscribe((result => {
      if (result) {
        this.modalRef.close();
      }
    }))
  }

  statusTextClass(status: CalendarEventStatusEnum | undefined) {
    if (status) {
      switch (status) {
        case CalendarEventStatusEnum.Accepted:
          return 'coloredTextArea green';
        case CalendarEventStatusEnum.Declined:
          return 'coloredTextArea red';
        case CalendarEventStatusEnum.Tentative:
          return 'coloredTextArea orange';
      }
    }
    return 'coloredTextArea grey';
  }

  statusText(status: CalendarEventStatusEnum | undefined) {
    switch (status) {
      case CalendarEventStatusEnum.None:
        return 'RSVP';
      case CalendarEventStatusEnum.Accepted:
        return 'Accepted';
      case CalendarEventStatusEnum.Declined:
        return 'Declined';
      case CalendarEventStatusEnum.Tentative:
        return 'Tentative';
    }
    return 'None';
  }

  updateText(event: any) {
    this.model.description = event;
  }
}
